import { authenticatedApi } from '../api';

const API_NOTIFY_PATH = '/notify';

export const createSubscription = async (data) => authenticatedApi.post(
	`${API_NOTIFY_PATH}/subscribe`, data,
);
export const deleteSubscription = async (endpoint) => authenticatedApi.post(`${API_NOTIFY_PATH}/delete`, { endpoint });

export const disableNotifications = async (endpoint) => authenticatedApi.post(`${API_NOTIFY_PATH}/disable`, { endpoint });

export const enableNotifications = async () => authenticatedApi.post(`${API_NOTIFY_PATH}/enable`);
